export default (monthIndex: number) => {
    if (monthIndex > 11) return monthIndex - 12;
    if (monthIndex < 0) return monthIndex + 12;
    return monthIndex;
}